export default "__VITE_ASSET__DQXU3Lmi__"